import React from 'react'

const ErrorSistema = ({ texto }) => {
    return (
        <div className="card">
            <div className="card-container yellow-container">
                <div className="block bg-yellow-500 font-bold text-center     border-round ">
                    <p className="text-sm text-4xl scalein animation-duration-3000 animation-iteration-infinite ">¡Algo salió mal!</p>
                </div>
                <div className="block bg-white-500 font-bold text-center border-round border-1 border-yellow-400 ">
                    <p>Lo sentimos pero hubo un error durante el proceso.</p>
                    <p><span className='underline'>Por favor comuníquese con el Administrador del Sistema</span>.</p>
                    {/* <p><span className='underline'>{Mensajes.GET_ADMIN_SYSTEM}</span>.</p> */}
                </div>
            </div>
        </div>
    )
}

export default ErrorSistema
